import "unfetch/polyfill";

export default function findLdJson(
  apiUrl,
  apiKey,
  baseUrl,
  slug,
  moment = undefined
) {
  return new Promise(function(resolve, reject) {
    fetch(
      apiUrl +
        "event/ld-json/" +
        slug +
        "?&apiKey=" +
        apiKey +
        "&base_url=" +
        encodeURIComponent(baseUrl) +
        "&populate_moment=" +
        moment
    )
      .then(r => r.json())
      .then(data => {
        resolve(data);
      })
      .catch(reason => {
        reject(reason);
      });
  });
}
